import React from 'react';
import { Router } from 'react-router-dom';
import Routes from './routes';
import history from './services/history';
import GlobalStyles from './styles/global';

function App() {
  return (
    <Router history={history}>
      <GlobalStyles />
      <Routes />
      Server Chat: {process.env.REACT_APP_IP_SERVER_CHAT}
    </Router>
  );
}

export default App;
